import { render, staticRenderFns } from "./m-addKeyword.vue?vue&type=template&id=525b67e2&"
import script from "./m-addKeyword.vue?vue&type=script&lang=js&"
export * from "./m-addKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports